import { createContext } from 'react'
import type { createPageNavigationState } from '@/lib/navigation/page-state'

export const PageNavigationContext = createContext<ReturnType<typeof createPageNavigationState> | null>(null)
